import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import {
  selectIsFieldDetailsOpen,
  selectIsGroupDetailsOpen,
  selectIsHierarchyDetailsOpen,
} from '../../../redux/slices/form-builder-slice';
import FormBuilderFieldDetails from './form-builder-field-details.component';
import { useGetLocalesQuery } from '../../../redux/services/api';
import FormBuilderGroupDetailsWrapper from './form-builder-group-details-wrapper.component';
import AdvancedHierarchyForm from '../fields/hierarchy-field/advanced-hierarchy-form.component';

const FormBuilderDetails = () => {
  const isFieldDetailsOpen = useAppSelector(selectIsFieldDetailsOpen);
  const isGroupDetailsOpen = useAppSelector(selectIsGroupDetailsOpen);
  const isHierarchyDetailsOpen = useAppSelector(selectIsHierarchyDetailsOpen);
  useGetLocalesQuery(); // preload locales for field details

  return (
    <>
      <div
        className="custom-scroll flex w-96 shrink-0 flex-col gap-3 overflow-y-auto border-l border-gray-4 pl-4"
        hidden={!isFieldDetailsOpen && !isGroupDetailsOpen && !isHierarchyDetailsOpen}
      >
        <div hidden={!isFieldDetailsOpen}>
          <FormBuilderFieldDetails />
        </div>
        <div hidden={!isHierarchyDetailsOpen}>
          <AdvancedHierarchyForm />
        </div>
        <div hidden={!isGroupDetailsOpen}>
          <FormBuilderGroupDetailsWrapper />
        </div>
      </div>
    </>
  );
};

export default React.memo(FormBuilderDetails);
